module.exports = "/assets/delice-page/hero.jpg?wXcDe2V";